/**
 * Nosto-CollectionProductCount.js
 *
 * Sincroniza la cantidad total de productos mostrada
 * en el encabezado de colección con la respuesta de Nosto.
 */

(function initializeNostoCollectionProductCount(global) {
    "use strict";

    const SELECTOR = "[data-nosto-products-quantity]";

    function updateProductCount(response) {
        const total = Number(
            response?.products?.total
        );

        if (!Number.isFinite(total) || total < 0) {
            return;
        }

        document
            .querySelectorAll(SELECTOR)
            .forEach((container) => {
                const valueElement =
                    container.querySelector(
                        "[data-nosto-products-quantity-value]"
                    );

                const labelElement =
                    container.querySelector(
                        "[data-nosto-products-quantity-label]"
                    );

                if (valueElement) {
                    valueElement.textContent =
                        String(total);
                }

                if (labelElement) {
                    labelElement.textContent =
                        total === 1
                            ? "producto"
                            : "productos";
                }

                container.hidden = false;

                container.dataset.nostoProductTotal =
                    String(total);
            });
    }

    function handleResponse(event) {
        updateProductCount(
            event.detail?.response
        );
    }

    document.addEventListener(
        "nosto:plp:response",
        handleResponse
    );

    document.addEventListener(
        "nosto:featured-plp:response",
        handleResponse
    );

    document.addEventListener(
        "nosto:carousel-plp:response",
        handleResponse
    );

    global.NostoCollectionProductCount = {
        update: updateProductCount,
    };
})(window);